import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Paper,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TabPanel from "../../../component/TabPanel";
import { handleAxiosError } from "../../../config/action-config";
import {
  deleteCommission,
  getCommissionById,
  getCompanyList,
  getPartners,
  updateCommission,
} from "../../../api/commissions";
import { showAlert } from "../../../actions/alert";
import DeleteDialog from "../../../component/DeleteDialogDetailPage";

const emptyCommissionData = {
  partner_id: "",
  lead_id: "",
  cloud_sales: "",
  services_sales: "",
  deal_value_closed: "",
};
export default function ViewCommissions() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [commissionDetailData, setCommissionDetailData] =
    useState(emptyCommissionData);
  const [partnerListData, setPartnerListData] = useState([]);
  const [companyListData, setCompanyListData] = useState([]);
  const [open, setOpen] = useState(false);
  const onInputChange = (e) => {
    setCommissionDetailData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);

  useEffect(() => {
    partnerList();
    companyList();
  }, []);

  async function loadMasterData() {
    try {
      const { data } = await getCommissionById(params.id, user.token);
      setCommissionDetailData(data.commission);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function onCommissionUpdate() {
    const combineData = {
      partner_id: commissionDetailData.partner_id,
      lead_id: commissionDetailData.lead_id,
      cloud_sales: commissionDetailData.cloud_sales,
      services_sales: commissionDetailData.services_sales,
      deal_value_closed: commissionDetailData.deal_value_closed,
    };
    try {
      const { data } = await updateCommission(
        params.id,
        combineData,
        user.token
      );
      loadMasterData();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function partnerList() {
    try {
      const { data } = await getPartners(user.token);
      setPartnerListData(data.data);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function companyList() {
    try {
      const { data } = await getCompanyList(user.token);
      setCompanyListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onDelete = () => {
    deleteCommission(params.id, user.token)
      .then((res) => {
        if (res.data.status == true) {
          navigate("/commissions");
          dispatch(showAlert(res.data.msg));
        } else {
          dispatch(showAlert(res.data.msg));
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  return (
    <Box sx={{ flexGrow: 1}}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        ></Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl required fullWidth>
              <InputLabel id="demo-simple-select-label-a">
                Partner Name
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-a"
                id="demo-simple-select-a"
                value={commissionDetailData.partner_id || ""}
                label=" Partner Name"
                name="partner_id"
                onChange={(event) => {
                  let selectedPartner = partnerListData.find((s) => {
                    return s.id === event.target.value;
                  });

                  onInputChange({
                    target: {
                      name: "partner_id",
                      value: selectedPartner.id,
                    },
                  });
                }}
              >
                {partnerListData.map((p, i) => (
                  <MenuItem key={i} value={p.id}>
                    {p.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl required fullWidth>
              <InputLabel id="demo-simple-select-label-a">
                Company Name
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-a"
                id="demo-simple-select-a"
                value={commissionDetailData.lead_id || ""}
                label=" Company Name"
                name="lead_id"
                onChange={(event) => {
                  let selectedCompany = companyListData.find((s) => {
                    return s.lead_id === event.target.value;
                  });

                  onInputChange({
                    target: {
                      name: "lead_id",
                      value: selectedCompany.lead_id,
                    },
                  });
                }}
              >
                {companyListData.map((c, i) => (
                  <MenuItem key={i} value={c.lead_id}>
                    {c.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="deal_value_closed"
              label="Deal Value Closed($)"
              value={commissionDetailData.deal_value_closed || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="cloud_sales"
              label="Cloud Sales($)"
              value={commissionDetailData.cloud_sales || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="services_sales"
              label="Services Sales($)"
              value={commissionDetailData.services_sales || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            {
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  variant="contained"
                  onClick={onCommissionUpdate}
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
                {/* <Button
                  variant="contained"
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ padding: "5px 7px" }}
                >
                  Delete
                </Button> */}
              </Box>
            }
          </Grid>
        </Grid>
      </Paper>
      <br />
      <DeleteDialog open={open} setOpen={setOpen} onDelete={onDelete} />
    </Box>
  );
}
